import { BookmarkDc, PositionDc, ProjectConfigurationDc } from "@evergis/api";
import { DEFAULT_SRID } from "@evergis/react";
import { RangeValue } from "@evergis/ui";

import { ResourceInfoDc } from "../../../modules/Catalog/types";

export const DEFAULT_LAYER_OPACITY = 1;

type ProjectContent = {
  items: ProjectContentItem[];
  resolution?: number;
  position?: PositionDc;
  srid?: number;
  baseMapName?: string;
  bookmarks?: BookmarkDc[];
};

type ProjectContentItem = {
  name: string;
  isVisible: boolean;
  opacity: number;
  minScale: number;
  maxScale: number;
};

enum MapDefaults {
  RESOLUTION = 38.21851414257816,
  POSITION_X = 4186550.5311808344,
  POSITION_Y = 7502440.006163074,
}

export const DEFAULT_BASE_MAP = "2gis";

export const DEFAULT_PROJECT_CONTENT: ProjectConfigurationDc = {
  resolution: MapDefaults.RESOLUTION,
  position: [MapDefaults.POSITION_X, MapDefaults.POSITION_Y],
  srid: DEFAULT_SRID,
};

export const createLayerItem =
  (minScale, maxScale) =>
  ({ name, alias = null, isVisible = true }: { name: string; alias?: string; isVisible?: boolean }) => ({
    name,
    alias,
    isVisible,
    opacity: DEFAULT_LAYER_OPACITY,
    minScale,
    maxScale,
  });

export const createLayerItems = (layers: ResourceInfoDc[], minScale, maxScale): ProjectContentItem[] =>
  layers.map(createLayerItem(minScale, maxScale));

export function createProjectContent(
  layers: ResourceInfoDc[],
  defaultProjectContent: ProjectConfigurationDc,
  defaultScaleRange: RangeValue,
): ProjectContent {
  return {
    ...defaultProjectContent,
    items: createLayerItems(layers, defaultScaleRange[0], defaultScaleRange[1]),
  };
}
